export { zhTw } from '@payloadcms/translations/languages/zhTw'
